/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";

import { formatDate } from "../../../helpers/date";

import NumberCell from "../../tableFields/NumberCell";

export const RETAINER_OR_CLIENT_CARE_CONTRACTS_COLUMNS = [
  {
    Header: "Contract Name",
    accessor: "name",
    id: "name",
    Cell: ({ value }) => value || "--",
    minWidth: 280
  },
  {
    Header: "Customer",
    accessor: "customer",
    id: "customer",
    Cell: ({ value }) => value || "--",
    minWidth: 280
  },
  {
    Header: "Status",
    accessor: "contract_status",
    id: "contract_status",
    Cell: ({ value }) => value || "--",
    minWidth: 80
  },
  {
    Header: "Start Date",
    id: "start_date",
    accessor: "start_date",
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : "--"),
    minWidth: 110
  },
  {
    Header: "End Date",
    accessor: "end_date",
    id: "end_date",
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : "--"),
    minWidth: 110
  },
  {
    Header: "Amount",
    accessor: "annual_amt",
    id: "annual_amt",
    Cell: ({ value }) => (
      <NumberCell value={value || value === 0 ? `$${value || 0}` : "--"} />
    ),
    minWidth: 80
  },
  {
    Header: "Total Usage",
    accessor: "totalUsage",
    id: "totalUsage",
    Cell: ({ value }) => <NumberCell value={value || 0} />,
    minWidth: 100
  },
  {
    Header: "Yield",
    accessor: "yield",
    id: "yield",
    Cell: ({ value }) => (
      <NumberCell value={value || value === 0 ? `$${value || 0}` : "--"} />
    ),
    minWidth: 120
  },
  {
    Header: "Type",
    accessor: "contract_type",
    id: "contract_type",
    Cell: ({ value }) => value || "--",
    minWidth: 180
  },
  {
    Header: "Notes",
    accessor: "notes",
    id: "notes",
    Cell: ({ value }) => value || "--",
    minWidth: 200
  }
];
